import GrupoFamiliar from "./GrupoFamiliar";
export default GrupoFamiliar;